import { FC } from "react";
import { Trans } from "@lingui/macro";
import { connectRefinementList } from "react-instantsearch-dom";
import { Hit, RefinementListProvided } from "react-instantsearch-core";
import { orderBy } from "lodash-es";
import { DropdownOutlined } from "src/atoms/DropDown";
import ColorFilter from "./ColorFilter";

interface Props extends RefinementListProvided {
  items: Hit<{
    count: number;
    isRefined: boolean;
    label: string;
    value: string[];
  }>[];
  refine: (str: string[]) => void;
  filterIndex: number;
  currentRefinement: string[];
  outerRef: React.RefObject<HTMLDivElement>;
  setCurrentIndex: (index: number) => () => void;
  closeFilters: () => void;
  opened: boolean;
}

const RefinementList: FC<Props> = ({
  items,
  refine,
  filterIndex,
  outerRef,
  setCurrentIndex,
  closeFilters,
  opened,
}) => {
  if (!items || !items.length) {
    return null;
  }

  return (
    <DropdownOutlined opened={opened}>
      <DropdownOutlined.Button
        onClick={setCurrentIndex(filterIndex)}
        data-testid={`color-filter-button`}
      >
        <span>
          <Trans>Colour</Trans>
        </span>
      </DropdownOutlined.Button>
      <DropdownOutlined.Items data-testid={`color-filter-list`}>
        <ColorFilter
          items={orderBy(items, "count", "desc")}
          refine={refine}
          outerRef={outerRef}
          onClose={closeFilters}
        />
      </DropdownOutlined.Items>
    </DropdownOutlined>
  );
};

const ColorRefinementList = connectRefinementList(RefinementList);

export default ColorRefinementList;
